import { render } from "./TreatmentDiseaseList.vue?vue&type=template&id=25c6e7d9"
import script from "./TreatmentDiseaseList.vue?vue&type=script&lang=js"
export * from "./TreatmentDiseaseList.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__